import BaseballResultsProcessor from "../../entities/BaseballResultsProcessor.js";
import DataSection from "../../enums/DataSection.js";
import ResultDataNew from "../../enums/ResultDataNew.js";
import Session from "../../enums/Session.js";

const scoringTypePath = ResultDataNew.getDataPath(DataSection.ScoringType.key);

const scoringTypeNotIn = function(session, scoringTypes) {
    if (!(scoringTypes instanceof Array)) {
        throw new Error('scoringTypes must be an array.');
    }

    if (!(session[Session.results.key] instanceof Array)) {
        return false;
    }

    if (session[Session.results.key].length < 1) {
        return false;
    }

    const firstResult = session[Session.results.key][0];
    const scoringType = BaseballResultsProcessor.getObjectContent(firstResult, scoringTypePath);

    // see https://bitbucket.org/flightscope/dto-schema/src/7cc26ca2fbddda72e96c2a756024083ba35837ad/baseball/entity/result-v2.json#lines-93
    return !scoringTypes.includes(scoringType);
};

export default scoringTypeNotIn;